import {AutoComplete, Button, Checkbox, Flex, Form, Modal, Typography} from 'antd';
import {
    acceptRules,
    SelectHomeCourseModalStore,
    setHomeCourse,
    useHomeCourseModalVisible,
    useLoadRules,
    useSetHomeCourse
} from "./SelectHomeCourseModalStore";
import {Store} from "pullstate";
import {useEffect} from "react";
import {toast} from "react-toastify";


export const SearchHomeCourseStore = new Store({
    search: '',
    filteredLocations: [],
    selected: false,
})


const SearchHomeCourse = () => {
    const {locations, selectedHomeCourse} = SelectHomeCourseModalStore.useState();
    const {search, filteredLocations, selected} = SearchHomeCourseStore.useState();
    useEffect(() => {
        SearchHomeCourseStore.update(s => {
            s.filteredLocations = locations.map(loc => {
                return {
                    value: loc.id,
                    label: `${loc.title}, ${loc.abbreviation}`
                }
            }).sort((a, b) => {
                return a.label.localeCompare(b.label, 'fi')
            });
        })

    }, [locations]);


    const selectedCourse = locations.find(loc => loc.id === selectedHomeCourse);
    const selectedHomeCourseLabel = selectedCourse ? `${selectedCourse?.title}, ${selectedCourse?.abbreviation}` : undefined


    const onChange = (value) => {
        // console.log('onChange', value)
        const selected = locations.find(loc => loc.id === value);
        if (selected) {
            SearchHomeCourseStore.update(s => {
                s.selected = selected;
            })
            setHomeCourse(value)
        } else {
            setHomeCourse(null)
            //     filter
            SearchHomeCourseStore.update(s => {
                s.search = value;
                s.selected = false;
                // s.
                s.filteredLocations = locations
                    .filter(loc => {
                        const searchString = loc.title + loc.abbreviation;
                        return searchString.toLowerCase().includes(value.toLowerCase())
                    })
                    .map(loc => {
                        return {
                            value: loc.id,
                            label: `${loc.title}, ${loc.abbreviation}`
                        }
                    })
                    .sort((a, b) => {
                        return a.label.localeCompare(b.label)
                    })
                ;
            });
        }
    }

    // console.log('selectedHomeCourseLabel', selectedHomeCourseLabel)
    return <AutoComplete
        onChange={onChange}
        options={filteredLocations}
        value={selectedHomeCourseLabel}
    />
}


export const SelectHomeCourseModal = () => {
    useLoadRules();

    const visible = useHomeCourseModalVisible();
    const {rules, locations, accepted, selectedHomeCourse, closable} = SelectHomeCourseModalStore.useState();
    const {selected,} = SearchHomeCourseStore.useState();
    const setCourse = useSetHomeCourse(selectedHomeCourse)
    const onOk = () => {
        SelectHomeCourseModalStore.update(s => {
            s.visible = false;
            s.closable = true;
        });
        toast.loading('Oma pelioikeus kenttä lisätään', {toastId: 'setHomeCourse'})
        setCourse(selectedHomeCourse)


    }
    return (
        <Modal
            title="Valitse oma nimetty pelioikeus kenttä ja hyväksy säännöt."
            visible={visible}
            onCancel={() => {
                SelectHomeCourseModalStore.update(s => {
                    s.visible = false;
                });
            }}
            closable={closable}
            footer={[
                <Button key="submit" type="primary" disabled={!selected || !accepted} onClick={onOk}>
                    Hyväksy ja jatka
                </Button>
            ]}
        >
            <Form>

                <Flex style={{height: '150px', alignItems: "center", overflow: 'scroll'}}>
                    <Typography.Text>
                        <div style={{ paddingTop: "10px",         paddingBottom: '10px', fontSize: '1.2em'}} dangerouslySetInnerHTML={{__html: rules}}/>
                    </Typography.Text>
                </Flex>
                <Form.Item>
                    <Checkbox checked={accepted} onChange={(e) => {
                        acceptRules(e.target.checked)
                    }}>Hyväksyn ehdot</Checkbox>
                </Form.Item>
                {accepted && (
                    <Form.Item
                        label="Oma nimetty pelioikeus kenttä"
                        name="homeCourse"
                        rules={[{required: true, message: 'Valitse oma nimetty pelioikeus kenttä'}]}
                    >
                        <SearchHomeCourse/>
                        <Typography.Text type="warning">Valitse oma nimetty pelioikeus kenttä</Typography.Text>
                    </Form.Item>
                )}


            </Form>
        </Modal>
    )
}
